/**
 * Indicates the key of the audit checks related to documents
 */
export enum AuditCheckDocumentKey {
    CheckDocumentDoublon = "hwABTc6o4Y0ZFNtxk8PpwxxcL",
    CheckDocumentNotBalanced = "NrVxEA4k5A9cWiaahscsOLM4A",
    CheckDocumentOutsideActiveAccountingPeriods = "YknERTQZISqBydS7sPZcNXoR",
    CheckDocumentNoDate = "zKsQgwB5qXmYotYqLG6I3MU4",
}
